import { useDispatch } from 'react-redux';
import { conversationStateValues } from '@rsos/reduxDataStore/src/features/conversations/conversations.typings';
import { getCallerIDFromConversation } from '@rsos/reduxDataStore/src/features/conversations/utils';
import { setSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import ToastBanner from '../base/Toast/ToastBanner';
import { getToastButtonText, getToastIcon, getToastMessage } from './helpers';

export interface ConversationsToastProps {
  conversation: conversationStateValues;
  handleButtonClick?: () => void;
}

/**
 * Toast content for a new TT911 conversation. Provides the conversation data
 * and click behavior to the shared ToastBanner layout: clicking the banner or
 * its button selects the conversation's caller ID, unless the caller passes
 * its own handler.
 */
function ConversationsToast({
  conversation,
  handleButtonClick,
}: ConversationsToastProps) {
  const dispatch = useDispatch();

  const handleOpen = () => {
    if (handleButtonClick) {
      handleButtonClick();
      return;
    }
    dispatch(setSelectedCallerID(getCallerIDFromConversation(conversation)));
  };

  return (
    <ToastBanner
      dataName="conversations-toast"
      icon={getToastIcon()}
      buttonText={getToastButtonText(conversation.source)}
      buttonDataName="conversations-toast-view-button"
      onAction={handleOpen}
    >
      {getToastMessage(conversation)}
    </ToastBanner>
  );
}

export default ConversationsToast;
